{
  "title": "Vicious Mockery",
  "source": "Player's Handbook",
  "levelAndSchool": "Enchantment cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You unleash a string of insults laced with subtle enchantments at a creature you can see within range. If the target can hear you (though it need not understand you), it must succeed on a Wisdom saving throw or take 1d4 psychic damage and have disadvantage on the next attack roll it makes before the end of its next turn.",
    "At Higher Levels. This spell’s damage increases by 1d4 when you reach 5th level (2d4), 11th level (3d4), and 17th level (4d4)."
  ],
  "spellLists": ["bard"]
}
